function initLineItemDrawerToggle() {
  const drawer = document.querySelector('.line-item-configuration');
  const cartDrawer = document.querySelector('cart-drawer');
  const drawerTitle = document.querySelector('.line-item-configuration__title');

  if (!drawer || !drawerTitle) return;

  function toggleAnnouncementBar(isDrawerOpen) {
    if (announcementBar) {
      announcementBar.style.display = isDrawerOpen ? 'none' : 'block';
    }
  }

  function showSpinner() {
    window.SpinnerUtils.showLineItem(drawer);
  }

  function hideSpinner() {
    window.SpinnerUtils.hideLineItem(drawer);
  }

  function setupImageToggle() {
    const allSvgs = drawer.querySelectorAll('.line-item-configuration__svg-1, .line-item-configuration__svg-2');

    allSvgs.forEach(svg => {
      svg.style.cursor = 'pointer';
      svg.addEventListener('click', (e) => {
        const clickedSvg = e.currentTarget;
        const isDesktop = clickedSvg.closest('.line-item-configuration__media.desktop');
        const mediaContainer = isDesktop ?
          drawer.querySelector('.line-item-configuration__media.desktop') :
          drawer.querySelector('.line-item-configuration__media.mobile');

        const svg1 = mediaContainer.querySelector('.line-item-configuration__svg-1');
        const svg2 = mediaContainer.querySelector('.line-item-configuration__svg-2');
        const img1 = mediaContainer.querySelector('.line-item-configuration__media-1');
        const img2 = mediaContainer.querySelector('.line-item-configuration__media-2');

        if (clickedSvg.classList.contains('line-item-configuration__svg-1')) {
          svg1.style.opacity = '1';
          svg2.style.opacity = '0.25';
          img1.style.display = 'block';
          img2.style.display = 'none';
        } else {
          svg1.style.opacity = '0.25';
          svg2.style.opacity = '1';
          img1.style.display = 'none';
          img2.style.display = 'block';
        }
      });
    });
  }

  function updateImages(relativePathPreviewObj, imagePath) {
    const desktopImg1 = drawer.querySelector('.line-item-configuration__media.desktop .line-item-configuration__media-1');
    const desktopImg2 = drawer.querySelector('.line-item-configuration__media.desktop .line-item-configuration__media-2');
    const desktopSvg1 = drawer.querySelector('.line-item-configuration__media.desktop .line-item-configuration__svg-1');
    const desktopSvg2 = drawer.querySelector('.line-item-configuration__media.desktop .line-item-configuration__svg-2');
    const desktopMedia = drawer.querySelector('.line-item-configuration__media.desktop');

    const mobileImg1 = drawer.querySelector('.line-item-configuration__media.mobile .line-item-configuration__media-1');
    const mobileImg2 = drawer.querySelector('.line-item-configuration__media.mobile .line-item-configuration__media-2');
    const mobileSvg1 = drawer.querySelector('.line-item-configuration__media.mobile .line-item-configuration__svg-1');
    const mobileSvg2 = drawer.querySelector('.line-item-configuration__media.mobile .line-item-configuration__svg-2');
    const mobileMedia = drawer.querySelector('.line-item-configuration__media.mobile');

    [desktopImg1, desktopImg2, desktopSvg1, desktopSvg2, mobileImg1, mobileImg2, mobileSvg1, mobileSvg2].forEach(el => {
      if (el) {
        el.style.display = '';
        el.style.opacity = '';
        if (el.classList.contains('original-product-image')) {
          el.classList.remove('original-product-image');
        }
      }
    });

    if (desktopMedia) desktopMedia.style.background = '';
    if (mobileMedia) mobileMedia.style.background = '';

    function isValidRelativePath(path) {
      return path && path.relativePath && path.relativePath.trim() !== '';
    }

    const validRelativePaths = relativePathPreviewObj ? relativePathPreviewObj.filter(isValidRelativePath) : [];

    if (validRelativePaths.length > 0) {
      if (desktopImg1) desktopImg1.src = validRelativePaths[0].relativePath;
      if (mobileImg1) mobileImg1.src = validRelativePaths[0].relativePath;

      if (validRelativePaths.length === 1) {
        if (desktopImg2) desktopImg2.style.display = 'none';
        if (mobileImg2) mobileImg2.style.display = 'none';
        if (desktopSvg1) desktopSvg1.style.display = 'none';
        if (desktopSvg2) desktopSvg2.style.display = 'none';
        if (mobileSvg1) mobileSvg1.style.display = 'none';
        if (mobileSvg2) mobileSvg2.style.display = 'none';
      } else {
        if (desktopImg2) desktopImg2.src = validRelativePaths[1].relativePath;
        if (mobileImg2) mobileImg2.src = validRelativePaths[1].relativePath;

        if (desktopImg2) desktopImg2.style.display = 'none';
        if (mobileImg2) mobileImg2.style.display = 'none';
        if (desktopSvg1) desktopSvg1.style.opacity = '1';
        if (desktopSvg2) desktopSvg2.style.opacity = '0.25';
        if (mobileSvg1) mobileSvg1.style.opacity = '1';
        if (mobileSvg2) mobileSvg2.style.opacity = '0.25';

        setupImageToggle();
      }
    } else if (imagePath) {
      if (desktopImg1) {
        desktopImg1.src = imagePath;
        if (!desktopImg1.classList.contains('original-product-image')) {
          desktopImg1.classList.add('original-product-image');
        }
      }
      if (mobileImg1) mobileImg1.src = imagePath;
      if (desktopImg2) desktopImg2.style.display = 'none';
      if (mobileImg2) mobileImg2.style.display = 'none';
      if (desktopSvg1) desktopSvg1.style.display = 'none';
      if (desktopSvg2) desktopSvg2.style.display = 'none';
      if (mobileSvg1) mobileSvg1.style.display = 'none';
      if (mobileSvg2) mobileSvg2.style.display = 'none';

      if (desktopMedia) desktopMedia.style.background = 'none';
      if (mobileMedia) mobileMedia.style.background = 'none';
    }
  }

  function populateConfiguration(consumerUserProductAttributes, relativePathPreviewObj, stepTitles) {
    const configContainer = drawer.querySelector('.line-item-configuration__config-container');
    const modelType1 = drawer.querySelector('.line-item-configuration__config-model-type-1');
    const modelType2 = drawer.querySelector('.line-item-configuration__config-model-type-2');

    if (!configContainer || !consumerUserProductAttributes) return;

    const hasMultipleItems = relativePathPreviewObj && relativePathPreviewObj.length === 2;

    if (modelType1) modelType1.style.display = hasMultipleItems ? 'block' : 'none';
    if (modelType2) modelType2.style.display = hasMultipleItems ? 'block' : 'none';

    const existingGroups = configContainer.querySelectorAll('.line-item-configuration__config-group');
    existingGroups.forEach(group => group.remove());

    if (hasMultipleItems) {
      const { jacketAttributes, trousersAttributes } = categorizeAndSortAttributes(consumerUserProductAttributes, stepTitles);

      jacketAttributes.sort((a, b) => a.originalIndex - b.originalIndex);
      let insertAfter = modelType1;
      jacketAttributes.forEach(attr => {
        const configGroup = createConfigGroup(attr);
        insertAfter.insertAdjacentElement('afterend', configGroup);
        insertAfter = configGroup;
      });

      trousersAttributes.sort((a, b) => a.originalIndex - b.originalIndex);
      insertAfter = modelType2;
      trousersAttributes.forEach(attr => {
        const configGroup = createConfigGroup(attr);
        insertAfter.insertAdjacentElement('afterend', configGroup);
        insertAfter = configGroup;
      });
    } else {
      consumerUserProductAttributes.forEach((attr, originalIndex) => {
        if (!attr.attributeValue || attr.attributeValue.trim() === '') {
          return;
        }

        attr.stepTitle = stepTitles && stepTitles[originalIndex] ? stepTitles[originalIndex] : null;
        const configGroup = createConfigGroup(attr);
        configContainer.appendChild(configGroup);
      });
    }
  }

  function categorizeAndSortAttributes(consumerUserProductAttributes, stepTitles) {
    const jacketAttributes = [];
    const trousersAttributes = [];

    const trousersKeywords = [
      'Hem-Width', 'Turn-Up', 'Tailored-Waistband', 'Trousers-Pleats',
      'Belt', 'Back-Pockets', 'Coin-Pocket', 'Suspender-Buttons', 'Fly-Front'
    ];

    consumerUserProductAttributes.forEach((attr, originalIndex) => {
      if (!attr.attributeValue || attr.attributeValue.trim() === '') {
        return;
      }

      attr.originalIndex = originalIndex;
      attr.stepTitle = stepTitles && stepTitles[originalIndex] ? stepTitles[originalIndex] : null;

      const attributeName = attr.attribute.name;
      const isTrousers = trousersKeywords.some(keyword => attributeName.includes(keyword));

      if (isTrousers) {
        trousersAttributes.push(attr);
      } else {
        jacketAttributes.push(attr);
      }
    });

    return { jacketAttributes, trousersAttributes };
  }

  function createConfigGroup(attr) {
    const configGroup = document.createElement('div');
    configGroup.className = 'line-item-configuration__config-group';

    const configTitle = document.createElement('div');
    configTitle.className = 'line-item-configuration__config-title';

    configTitle.textContent = attr.stepTitle || attr.attribute.name.replace('CFG-SUIT-', '').replace(/-/g, ' ');

    const configDescription = document.createElement('div');
    configDescription.className = 'line-item-configuration__config-description';
    configDescription.textContent = attr.attributeValue;

    configGroup.appendChild(configTitle);
    configGroup.appendChild(configDescription);

    return configGroup;
  }

  document.body.addEventListener('click', async (e) => {
    const openTrigger = e.target.closest('.line-item-configuration__open');
    const closeTrigger = e.target.closest('.line-item-configuration__close');

    if (openTrigger) {
      if (cartDrawer) {
        const wasVisible = cartDrawer.classList.contains('is-visible');
        cartDrawer.setAttribute('data-was-visible', wasVisible ? 'true' : 'false');
        if (wasVisible) {
          cartDrawer.classList.remove('is-visible');
        }
      }

      const productTitle = openTrigger.getAttribute('data-title');
      if (productTitle) {
        drawerTitle.textContent = productTitle;
      }

      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      
      toggleAnnouncementBar(true);
      
      showSpinner();

      const userProductId = openTrigger.getAttribute('data-consumer');
      if (userProductId) {
        try {
          const result = await apiService.getConsumerProduct(userProductId);

          updateImages(result.data.relativePathPreviewObj, result.data.imagePath);
          populateConfiguration(result.data.consumerUserProductAttributes, result.data.relativePathPreviewObj, result.data.stepTitles);
          hideSpinner();

        } catch (error) {
          if (error instanceof ApiError) {
            console.error(`API Error getting consumer product:`, error);
          } else {
            console.error(`Network error getting consumer product:`, error);
          }
          hideSpinner();
        }
      }
    }

    if (closeTrigger) {
      drawer.classList.remove('open');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      drawerTitle.textContent = '';
      toggleAnnouncementBar(false);

      if (cartDrawer.getAttribute('data-was-visible') === 'true') {
        cartDrawer.classList.add('is-visible');
      }
      if (cartDrawer) {
        if (cartDrawer.getAttribute('data-was-visible') === 'true') {
          cartDrawer.classList.add('is-visible');
        }

        cartDrawer.removeAttribute('data-was-visible');
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initLineItemDrawerToggle);